module.exports = __webpack_public_path__ + "assets/img/block-right-411de655.png";